<template>
  <SubSidebarLayout :menu-categories="menuCategories" />
</template>
<script>
import SubSidebarLayout from '@/components/sidebars/SubSidebarLayout'

export default {
  components: {
    SubSidebarLayout
  },
  data: () => ({
    menuCategories: [
      {
        name: '基本設定',
        items: [{ text: '設定', router: { name: 'adminSettings' } }]
      },
      {
        name: 'その他',
        items: [
          { text: 'RSS設定', router: { name: 'adminRssSettings' } },
          {
            text: 'お問い合わせ一覧',
            situation: 'contact_management',
            router: { name: 'adminContacts' }
          },
          {
            text: '固定ページ',
            situation: 'media_page_management',
            router: { name: 'adminMediaPages' }
          },
          {
            text: 'HTMLページ',
            situation: 'html_page_management',
            router: { name: 'adminHtmlPages' }
          },
          {
            text: 'フッターリンク',
            situation: 'footer_link_management',
            router: { name: 'adminFooterLinks' }
          },
          {
            text: 'リダイレクト設定',
            router: { name: 'adminMediaRedirections' }
          },
          {
            text: 'ギャラリー管理',
            router: { name: 'adminExhibitManagement' }
          }
        ]
      }
    ]
  })
}
</script>
